import { Grid } from "designSystem/index";
import MultiSelect from "designSystem/components/select/MultiSelect";
import React from "react";
import { items } from "designSystemLegacy/data";

export default () => {
	return (
		<Grid
			container
			direction="column"
			spacing={4}
		>
			<Grid item>
				<MultiSelect
					options={items}
					value={[items[0]]}
				/>
			</Grid>
		</Grid>
	);
};